import { render, staticRenderFns } from "./Backtotop.vue?vue&type=template&id=233bb208&scoped=true&"
import script from "./Backtotop.vue?vue&type=script&lang=js&"
export * from "./Backtotop.vue?vue&type=script&lang=js&"
import style0 from "./Backtotop.vue?vue&type=style&index=0&id=233bb208&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233bb208",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VFadeTransition,VIcon})
